import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { GapWrapper, GapContainer } from './styles.js';
import { getGapDimensions } from './utils.js';

var Gap = function Gap(_ref) {
  var children = _ref.children,
      size = _ref.size,
      props = _objectWithoutProperties(_ref, ["children", "size"]);

  var dimensions = getGapDimensions(size);
  var wrapperHorizontalMargin = "calc(-".concat(dimensions.x, " / 2)");
  var wrapperVerticalMargin = "calc(-".concat(dimensions.y, " / 2)");
  var childHorizontalMargin = "calc(".concat(dimensions.x, " / 2)");
  var childVerticalMargin = "calc(".concat(dimensions.y, " / 2)");
  return /*#__PURE__*/React.createElement(GapWrapper, _extends({
    "data-test": "elemental-Gap",
    display: "flex",
    flexWrap: "wrap"
  }, props, {
    mh: wrapperHorizontalMargin,
    mv: wrapperVerticalMargin
  }), React.Children.map(children, function (child) {
    return (// child can be undefined if parent has {condition && <SomeElement/>}
      child && /*#__PURE__*/React.createElement(GapContainer, {
        mh: childHorizontalMargin,
        mv: childVerticalMargin
      }, child)
    );
  }));
};

export { Gap };
